export default "__VITE_ASSET__fbfab89d__"